export type OpeningTimeSentinel =
  | 'NOT_AVAILABLE'
  | 'OPEN_24_HOURS'
  | 'CLOSED_24_HOURS';

export type ExceptionalOpeningTimeSentinel = Exclude<
  OpeningTimeSentinel,
  'NOT_AVAILABLE'
>;

export interface TimeOfDay {
  hour: number;
  minute: number;
}

export interface OpeningTimeRange {
  start: TimeOfDay;
  end: TimeOfDay;
}

export interface ExceptionalPeriod {
  startDate: string;
  endDate: string;
}

export interface ExceptionalOpeningHoursV2 {
  label?: string | null;
  period: ExceptionalPeriod;
  time: OpeningTimeRange[] | ExceptionalOpeningTimeSentinel;
}

export const gymDays = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
  'publicHoliday',
] as const;

export type GymDay = (typeof gymDays)[number];

export interface OpeningHoursV2 extends Record<GymDay, OpeningTimeRange[] | OpeningTimeSentinel> {
  exceptions: ExceptionalOpeningHoursV2[];
  additionalInfo: string | null;
}
